import React from 'react';
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn, FaWhatsapp } from 'react-icons/fa';

const Footer = () => {
    return (
        <footer className="bg-gray-200 text-black py-8">
            <div className="max-w-7xl mx-auto px-4 grid grid-cols-1 md:grid-cols-3 gap-8">
                {/* About Section */}
                <div>
                    <h2 className="text-lg font-semibold mb-4">معلومات عنا</h2>
                    <p className="text-sm text-gray-700">
                        نحن منصة متخصصة في توفير تدريب احترافي مركز و فردي للمتدربين مع
                        مدرب ذو خبرة و متخصص في مجالك                    
                        </p>
                </div>

                {/* Quick Links */}
                <div>
                    <h2 className="text-lg font-semibold mb-4">روابط سريعة</h2>
                    <ul className="space-y-2">
                        <li><a href="/home" className="hover:text-primary-400">الرئيسية</a></li>
                        <li><a href="/chat" className="hover:text-primary-400">المحادثات</a></li>
                        <li><a href="/about-us" className="hover:text-primary-400">معلومات عنا</a></li>
                        <li><a href="/contact-us" className="hover:text-primary-400">تواصل معنا</a></li>
                    </ul>
                </div>

                {/* Social Media Links */}
                <div>
                    <h2 className="text-lg font-semibold mb-4">تابعنا</h2>
                    <div className="flex space-x-4">
                        <a href="#" className="hover:text-primary-400">
                            <FaFacebookF />
                        </a>
                        <a href="#" className="hover:text-primary-400">
                            <FaTwitter />
                        </a>
                        <a href="#" className="hover:text-primary-400">
                            <FaInstagram />
                        </a>
                        <a href="#" className="hover:text-primary-400">
                            <FaLinkedinIn />
                        </a>
                        <a target='_blank' href="https://wa.me/+201040907137" className="hover:text-primary-400 text-xl" rel="noreferrer">
                            <FaWhatsapp />
                        </a>
                    </div>
                </div>
            </div>

            {/* Footer Bottom */}
            <div className="mt-8 text-center text-sm text-gray-500 border-t border-gray-700 pt-4">
                © {new Date().getFullYear()} جميع الحقوق محفوظة
            </div>
        </footer>
    );
};

export default Footer;